// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * CallGroupService manages call groups.
 * NWX Endpoint, location-id is not used.
 */
export const CallGroupService = {
    /**
     * Create call group along with all call legs.
     * POST: /phone/callgroup/v1
     */
    Create(fn, req) {
        return fn(`/phone/callgroup/v1`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Read call group. Always includes CallLegs/Devices.
     * GET: /phone/callgroup/v1/{call_group_id}
     */
    Read(fn, req) {
        try {
            fm.validateUrlParam(req["callGroupId"], "callGroupId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callgroup/v1/${req["callGroupId"]}?${fm.renderURLSearchParams(req, ["callGroupId"])}`, { method: "GET" });
    },
    /**
     * List call groups. Exclude call legs.
     * GET: /phone/callgroup/v1/?tenant_id={tenant_id}
     */
    List(fn, req) {
        return fn(`/phone/callgroup/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Update call group such as name and ringtone. Excludes call legs.
     * PUT: /phone/callgroup/v1/{call_group_id}
     */
    Update(fn, req) {
        try {
            fm.validateUrlParam(req["callGroupId"], "callGroupId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callgroup/v1/${req["callGroupId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Delete call group.
     * DELETE: /phone/callgroup/v1/{call_group_id}
     */
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["callGroupId"], "callGroupId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callgroup/v1/${req["callGroupId"]}?${fm.renderURLSearchParams(req, ["callGroupId"])}`, { method: "DELETE" });
    },
    /**
     * Assign a device to a call group.
     * POST: /phone/callgroup/v1/device
     */
    AssignDevice(fn, req) {
        return fn(`/phone/callgroup/v1/device`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Update a device in a call group.
     * PUT: /phone/callgroup/v1/device
     */
    UpdateDevice(fn, req) {
        return fn(`/phone/callgroup/v1/device`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Update many devices in a call group.
     * Given a list of devices, update all devices in the call group.
     * Any devices not included in the list will be removed from the call group.
     */
    UpdateDevices(fn, req) {
        return fn(`/phone/callgroup/v1/devices`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Remove a device from a call group.
     * DELETE: /phone/callgroup/v1/device/{call_leg_id}
     */
    RemoveDevice(fn, req) {
        try {
            fm.validateUrlParam(req["callLegId"], "callLegId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callgroup/v1/device/${req["callLegId"]}?${fm.renderURLSearchParams(req, ["callLegId"])}`, { method: "DELETE" });
    },
    /**
     * Usage returns where the call group is being used. Returns empty if not being used.
     * GET: /phone/callgroup/v1/{call_group_id}/usage
     */
    Usage(fn, req) {
        try {
            fm.validateUrlParam(req["callGroupId"], "callGroupId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callgroup/v1/${req["callGroupId"]}/usage?${fm.renderURLSearchParams(req, ["callGroupId"])}`, { method: "GET" });
    },
};
